import { Label } from 'semantic-ui-react';
import { useMemo } from 'react';
import { getOrigin } from 'modules/get-origin/get-origin';

export default function UserGroupLabel({ groupName, ...props }) {
  const origin = useMemo(() => getOrigin(groupName), [groupName]);

  return (
    <Label color={origin.color} size="small" {...props}>
      {origin.name}
    </Label>
  );
}
